import createRoutePath from '@api/endpoints/createEndpointPath';

import { getBranchEnvironment } from '@app/redux/branchEnvironment/branchEnvironment.selectors';
import { useAppSelector } from '@app/redux/hooks';

function useGenerateRoutePath() {
	const branchEnvironment = useAppSelector(getBranchEnvironment);
	return (rawPath: ReturnType<typeof createRoutePath>, { withRequiredQueryParams = true } = {}) => {
		return rawPath(
			{ branchRoute: branchEnvironment.branch_route, repRoute: branchEnvironment.rep_route },
			{ withRequiredQueryParams: branchEnvironment.is_branch_from_query_params && withRequiredQueryParams },
		);
	};
}

export default useGenerateRoutePath;
